module.exports = () => {
  return {
    postcssPlugin: 'postcss-remove-dark-mode',
    AtRule(atRule) {
      if (
        atRule.name === 'media' &&
        atRule.params.includes('prefers-color-scheme')
      ) {
        atRule.remove(); // remove dark mode media queries
      }
    },
  };
};
module.exports.postcss = true;
